// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import ResourceLinkViewModel from '../../../../viewModel/resource/ResourceLinkViewModel';
import MembershipDocumentListResourceViewModel from '../../../../viewModel/resource/MembershipDocumentListResourceViewModel';
import MembershipDocumentListResourceDTO from '../../dto/resource/MembershipDocumentListResourceDTO';

export default abstract class MembershipDocumentListResourceModel extends BaseModel<MembershipDocumentListResourceDTO> {
  /**
  * @type {uuid}
  */
  get id() { return this.dto.id; }
  set id(value) { this.dto.id = value; }
  /**
  */
  get links() { return this.getArrayModels(() => this.dto.links, ResourceLinkViewModel)!; }
  set links(value) { this.setArrayModels(() => this.dto.links, value); }
  /**
  */
  get subject() { return this.dto.subject; }
  set subject(value) { this.dto.subject = value; }
  /**
  */
  get documentType() { return this.dto.documentType; }
  set documentType(value) { this.dto.documentType = value; }
  /**
  */
  get fileExtension() { return this.dto.fileExtension; }
  set fileExtension(value) { this.dto.fileExtension = value; }
  /**
  */
  get downloadUrl() { return this.dto.downloadUrl; }
  set downloadUrl(value) { this.dto.downloadUrl = value; }
  /**
  * @type {date-time}
  */
  get createdOn() { return this.dto.createdOn; }
  set createdOn(value) { this.dto.createdOn = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    this.dto.id = qs.id;
    this.dto.subject = qs.subject;
    this.dto.documentType = qs.documenttype;
    this.dto.fileExtension = qs.fileextension;
    this.dto.downloadUrl = qs.downloadurl;
    this.dto.createdOn = qs.createdon;
  }
}
